import '../css/app.css';
import './bootstrap';

import { createInertiaApp } from '@inertiajs/react';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { TooltipProvider } from './components/ui/tooltip';
import { ThemeProvider } from './contexts/theme-context';
import { Toaster } from './components/ui/toaster';
import { GlobalErrorBoundary } from './components/global-error-boundary';

import { pageComponents } from './pages-explicit';

const appName = 'i2u.ai, Ideas to Unicorns through AI!';
const queryClient = new QueryClient();

const el = document.getElementById('app');
if (el && el.dataset.page) {
    createInertiaApp({
        title: (title) => title ? `${title} | ${appName}` : appName,
        resolve: (name) => {
            // First try custom explicit components (for production robustness)
            if (pageComponents && (pageComponents as any)[name]) {
                return (pageComponents as any)[name]();
            }
            // Fall back to standard auto-resolver
            return resolvePageComponent(
                `./pages/${name}.tsx`,
                import.meta.glob('./pages/**/*.tsx')
            );
        },
        setup({ el, App, props }) {
            const root = createRoot(el);
            root.render(
                <GlobalErrorBoundary>
                    <QueryClientProvider client={queryClient}>
                        <ThemeProvider>
                            <TooltipProvider>
                                <App {...props} />
                                <Toaster />
                            </TooltipProvider>
                        </ThemeProvider>
                    </QueryClientProvider>
                </GlobalErrorBoundary>
            );
        },
        progress: {
            color: '#4B5563',
        },
    });
}
